module.exports = __webpack_public_path__ + "img/55.72485fcf.jpg";